/**
 * <PrivacyFieldTooltip /> — v1.68 (Fase 5 Privacy Lokky-style).
 * Tooltip contestuale accanto ai campi sensibili nei wizard.
 *
 * Uso:
 *   <label>Email <PrivacyFieldTooltip finalita="email" /></label>
 */
import { useState } from "react";
import { Info } from "lucide-react";

const HINTS = {
  email:          "Ti contattiamo solo se hai spuntato 'Contatto commerciale' nel box consensi in fondo. Nessun uso marketing senza consenso esplicito.",
  telefono:       "Come per l'email: usiamo il telefono solo se hai spuntato 'Contatto commerciale'. Numero cifrato at-rest.",
  nome:           "Trattato con base giuridica art. 6.1.b GDPR (misure precontrattuali). Retention 10 anni ex Reg. IVASS 44/2019.",
  data_nascita:   "Utilizzata solo per calcoli tariffari (tipicamente età). Retention 10 anni. Nessuna profilazione automatizzata senza consenso.",
  codice_fiscale: "Trattato per adempimenti IVASS e antiriciclaggio (D. Lgs. 231/2007). Non condiviso con terzi al di fuori delle compagnie partner.",
  dati_sanitari:  "Cifrati at-rest AES-256-GCM. Solo consulenti abilitati con log audit possono decrifrare. Non usati per finalità diverse dalla quotazione (art. 9.2.a GDPR).",
};

export default function PrivacyFieldTooltip({ finalita, testIdPrefix = "field" }) {
  const [open, setOpen] = useState(false);
  const text = HINTS[finalita] || "Trattato secondo la nostra Privacy Policy.";
  return (
    <span className="relative inline-flex align-middle ml-1"
           data-testid={`${testIdPrefix}-tooltip-${finalita}`}>
      <button
        type="button"
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        onClick={(e) => { e.preventDefault(); setOpen((x) => !x); }}
        aria-label={`Info privacy campo ${finalita}`}
        className="text-[#4A5E51] hover:text-[#163321] inline-flex focus:outline-none"
      >
        <Info className="w-3.5 h-3.5" />
      </button>
      {open && (
        <span
          role="tooltip"
          data-testid={`${testIdPrefix}-tooltip-content-${finalita}`}
          className="absolute z-50 top-6 left-1/2 -translate-x-1/2 w-64 px-3 py-2 rounded-lg bg-[#0F1F14] text-white text-[11px] leading-relaxed shadow-lg"
        >
          {text}
        </span>
      )}
    </span>
  );
}
